module.exports = "//static.hsappstatic.net/LoginUI/static-1.14169/img/HubSpot-sprocket-color.png"